import translate from 'utils/translate';
import fetchPhraseIfNeeded from 'utils/fetch-phrase-if-needed';
const ALLOWED_SOURCES = ['cart_client'];
export const initGetLists = async ({ source }: { source: string }) => {
    if (
        !ALLOWED_SOURCES.includes(source) ||
        !window.location.href.includes('/shoppingcart')
    ) {
        throw new Error('Unauthorized');
    }
    return fetchPhraseIfNeeded().then(
        () =>
            import('../../api/list/index').then(({ getListsExtended }) =>
                getListsExtended().then(resp => {
                    return resp?.data?.lists.map(list => {
                        if (
                            list.name === translate('SAVED_FOR_LATER_LIST_NAME')
                        ) {
                            return { ...list, isSavedForLater: true };
                        }
                        if (!list.name) {
                            return {
                                ...list,
                                name: translate('DEFAULT_LIST_NAME'),
                            };
                        }
                        return list;
                    });
                })
            ) || []
    );
};
